import InputGroup from "@/components/InputGroup";
import { Button } from "@/components/ui/button";
import { saveUserInfo } from "@/lib/freeAssessment";
import { emailPattern } from "@/lib/regexPattern";
import { UserInfo } from "@/schema/free-assessment/UserInfo";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function InfoForm() {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserInfo>({
    mode: "onSubmit",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const refererId = params.get("refererId");
  var termsOfService = "https://koyouassess.biz/inquiry.html";
  var privacyPolicy = "https://koyouassess.biz/privacy_policy.html";
  if (refererId) {
    termsOfService = termsOfService + "?refererId=" + refererId;
    privacyPolicy = privacyPolicy + "?refererId=" + refererId;
  }


  return (
    <div className="rounded-xl bg-white p-6 shadow">
      <div className="text-xl font-bold text-cool-gray-800">
        {t("free-assessment-full")}
      </div>
      <div>
        {t("provide-info")}
      </div>
      <form
        onSubmit={handleSubmit((data) => {
          const params = new URLSearchParams(location.search);
          const refererId = params.get("refererId");
          if (refererId) {
            data.refererId = refererId;
          }
          saveUserInfo(data);
          navigate("/free-assessment/questions");
        })}
      >
        <div className="mt-8 grid w-full grid-cols-2 gap-6">
          <InputGroup
            label={t("company-or-belongs-name")}
            name="companyName"
            error={errors.companyName?.message}
            register={register("companyName", {
              required: t("company-name-required"),
            })}
            className="col-span-2"
          />
          <div className="col-span-2 text-cool-gray-800">
            {t("answerer-full-name")}
          </div>
          <InputGroup
            label={t("last-name")}
            name="lastName"
            className="col-span-2 sm:col-span-1"
            error={errors.lastName?.message}
            register={register("lastName", {
              required: t("last-name-required"),
            })}
          />
          <InputGroup
            label={t("first-name")}
            name="firstName"
            className="col-span-2 sm:col-span-1"
            error={errors.firstName?.message}
            register={register("firstName", {
              required: t("first-name-required"),
            })}
          />
          <InputGroup
            label={t("email")}
            name="email"
            error={errors.email?.message}
            register={register("email", {
              required: t("email-required"),
              pattern: {
                value: emailPattern,
                message: t("valid-email"),
              },
            })}
            className="col-span-2"
            type="email"
          />

          <Button type="submit" className="col-span-2">
            {t("start-assessment")}
          </Button>
          <div className="col-span-2 text-center text-xs text-cool-gray-500">
            <span>{t("agree-to")} </span>
            <Link
              to={termsOfService}
              className="text-cyan-600"
              target="_blank"
            >
              {t("terms-of-service")}
            </Link>
            <span> {t("and")} </span>
            <Link
              to={privacyPolicy}
              className="text-cyan-600"
              target="_blank"
            >
              {t("privacy-policy")}
            </Link>
            <span>{t("agree-end")}</span>
          </div>
        </div>
      </form>
    </div>
  );
}

export default InfoForm;
